export const keyColumnData = [
  {
    label: "Company Name",
    field: "company_name"
  },
  {
    label: "Website",
    field: "website"
  },
  {
    label: "Establishment Date",
    field: "establishment_date"
  },
  {
    label: "Registered Capital",
    field: "registered_capital"
  },
  {
    label: "Office Address",
    field: "office_address"
  },
  {
    label: "E-mail",
    field: "e_mail"
  },
  {
    label: "Telephone",
    field: "telephone"
  },
  {
    label: "Stock exchange(s) listed",
    field: "stock_exchange_listed"
  },
  {
    label: "Fax",
    field: "fax"
  },
  {
    label: "Securities Code",
    field: "securities_code"
  },
  {
    label: "Postal Code",
    field: "postal_code"
  },
  {
    label: "Securities Abbreviation",
    field: "securities_abbreviation"
  }
];

export const industryColumnData = [
  {
    label: "Primary business line",
    field: "primary_business_line"
  },
  {
    label: "Main activity",
    field: "main_activity"
  }, {
    label: "Main products and services",
    field: "main_products_and_services"
  }, {
    label: "Main domestic country",
    field: "main_domestic_country"
  }
]

export const idirectorsColumnData = [
  {
    label: "Executive Chairman",
    field: "executive_chairman"
  },
  {
    label: "Board of Directors",
    field: "board_of_directors"
  },
  {
    label: "Secretary",
    field: "secretary"
  },
  {
    label: "Executive Director",
    field: "executive_director"
  },
  {
    label: "Chief Executive Officer",
    field: "chief_executive_officer"
  }, {
    label: "Chief Financial Officer",
    field: "chief_financial_officer"
  }
]

export const auditorsColumnData = [
  {
    label: "Auditors",
    field: "auditors"
  },
  {
    label: "Bankers",
    field: "bankers"
  },
  {
    label: "Other advisors",
    field: "other_advisors"
  }
]

export const legalColumnData = [
  {
    label: "Date",
    field: "a"
  },
  {
    label: "Type",
    field: "b"
  },
  {
    label: "Description",
    field: "c"
  },
  {
    label: "Source",
    field: "d"
  },
  {
    label: "Registration ID",
    field: "e"
  },
  {
    label: "Currently",
    field: "f"
  },
  {
    label: "Formerly",
    field: "g"
  }
]


// 登陆  uesrid  1

// 三期   userid  =>  3permisonnUrl => {
//   1: ["CompanyIntroduction1","CompanyIntroduction2"],
//   select: [...]
// }

// erqi   userid   2pre 